import { Reveal, Overline } from "./Primitives";
import { SURFACES } from "@/data/content";
import { Leaf, ShieldCheck, ArrowUpRight } from "lucide-react";

export const EcoSurface = () => {
  const scrollToQuote = () =>
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="bg-[#0a0a0a] border-y border-white/10 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid gap-8 lg:grid-cols-2">
          {/* Eco-conscious */}
          <Reveal>
            <div className="h-full border border-white/10 bg-[#121212] p-8 md:p-10 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <Leaf className="text-gold" size={22} />
                <Overline>Eco-Conscious Cleaning Options</Overline>
              </div>
              <h2 className="font-display font-light tracking-tight text-3xl md:text-4xl leading-[1.1] text-white">
                A cleaner home. A more <span className="gold-gradient italic">thoughtful</span> approach.
              </h2>
              <p className="mt-5 text-base text-zinc-400 leading-relaxed flex-1">
                We believe exceptional cleaning and responsible product choices can go hand in hand. We offer
                eco-conscious options when appropriate for the service, surface and specific needs of your
                property—selecting and using products according to manufacturer instructions and labels, while
                considering surface compatibility, effectiveness and responsible use.
              </p>
              <p className="mt-4 font-display italic text-gold text-lg">Exceptional results, thoughtfully delivered.</p>
              <button
                data-testid="eco-cta"
                onClick={scrollToQuote}
                className="group mt-6 inline-flex items-center gap-2 border border-gold text-gold font-medium px-6 py-3.5 hover:bg-gold/10 transition-colors duration-300 self-start"
              >
                Ask About Eco-Conscious Options
                <ArrowUpRight size={17} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </button>
            </div>
          </Reveal>

          {/* Surface care */}
          <Reveal delay={0.1}>
            <div className="h-full border border-gold/25 bg-gradient-to-br from-[#151208] to-[#0a0a0a] p-8 md:p-10">
              <div className="flex items-center gap-3 mb-4">
                <ShieldCheck className="text-gold" size={22} />
                <Overline>We Respect Your Surfaces</Overline>
              </div>
              <p className="text-base text-zinc-300 leading-relaxed">
                Cleaning methods and products are selected with consideration for the surface material,
                condition and manufacturer's care recommendations whenever available.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {SURFACES.map((s) => (
                  <span
                    key={s}
                    className="text-[11px] uppercase tracking-[0.12em] text-zinc-300 border border-white/10 px-2.5 py-1.5 hover:border-gold/50 transition-colors"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
